"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9174],{

/***/ 69174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ home_PlacesSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/redux/actions/geolocation.js
var geolocation = __webpack_require__(47571);
// EXTERNAL MODULE: ./src/utils/geolocation.js
var utils_geolocation = __webpack_require__(53427);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-geolocated/dist-modules/index.js
var dist_modules = __webpack_require__(14681);
// EXTERNAL MODULE: ./node_modules/react-google-autocomplete/index.js
var react_google_autocomplete = __webpack_require__(82625);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./src/constants/rediscache.js
var rediscache = __webpack_require__(52560);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
;// CONCATENATED MODULE: ./src/components/home/PlacesSearch/helpers.js


var _this = undefined;


var getAddressData = function(param) {
    var address_components = param.address_components, formatted_address = param.formatted_address, geometry = param.geometry;
    var data = {
        formattedAddress: "",
        area: "",
        city: "",
        postal: "",
        address: "",
        state: "",
        latitude: 0,
        longitude: 0
    };
    data.formattedAddress = formatted_address;
    if (geometry) {
        data.latitude = geometry.location.lat();
        data.longitude = geometry.location.lng();
    }
    if (!(address_components === null || address_components === void 0 ? void 0 : address_components.length)) {
        return null;
    }
    address_components.forEach(function(address) {
        if (address.types && address.types.length !== 0) {
            address.types.forEach(function(addressType) {
                if ("sublocality_level_1" === addressType || "country" === addressType || "locality" === addressType) {
                    data.area = address.short_name;
                }
                if ("administrative_area_level_2" === addressType || "administrative_area_level_1" === addressType) {
                    data.city = address.long_name;
                }
                if ("postal_code" === addressType) {
                    data.postal = address.long_name;
                }
                if ("route" === addressType || "street_number" === addressType) {
                    data.address = address.long_name;
                }
                if ("administrative_area_level_1" === addressType) {
                    data.state = address.short_name;
                }
            });
        }
    });
    return data;
};
var requestLocation = function(toast, setLoadingCurrentGeolocation, setLocationPermissionApprovedLoading, provideData, geolocation, onGeolocationFound) {
    if (!navigator.geolocation) {
        toast.error("Geolocation is not supported by your browser");
        _this.requestLocation();
    }
    if (!navigator.geolocation) {
        toast.error("Geolocation is not supported by your browser");
        setLoadingCurrentGeolocation(false);
    } else {
        navigator.geolocation.getCurrentPosition(function(position) {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;
            setLoadingCurrentGeolocation(true);
            provideData(latitude, longitude, geolocation).then(function(data) {
                setLoadingCurrentGeolocation(false);
                setLocationPermissionApprovedLoading(false);
                onGeolocationFound(data);
            });
        }, function(error) {
            if (error.code == 3 && !geolocation.latitude) {
                toast.error("We were unable to retrieve your location. Please enter it manually in the location form");
            }
            setLoadingCurrentGeolocation(false);
            setLocationPermissionApprovedLoading(false);
        }, {
            timeout: 30000,
            enableHighAccuracy: true,
            maximumAge: Infinity
        });
    }
};
var getIpAddress = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.get */.Z.get("https://geolocation-db.com/json/09ba3820-0f88-11eb-9ba6-e1dd7dece2b8", {
                            crossdomain: true
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getIpAddress() {
        return _ref.apply(this, arguments);
    };
}();
var getGeoLocationByLatLong = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(lat, long, geolocation) {
        var ipaddress, type, path, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getIpAddress()
                    ];
                case 1:
                    ipaddress = _state.sent();
                    type = "IP Address";
                    path = "".concat(rediscache/* default */.Z, "/geolocation?");
                    if (ipaddress) {
                        path = path + "ipaddress=".concat(ipaddress.IPv4);
                        if (!lat && !geolocation.latitude) {
                            lat = ipaddress.latitude;
                            long = ipaddress.longitude;
                        }
                    }
                    if (lat && long) {
                        type = "GeoLocation";
                        path = path + "&latitude=".concat(lat, "&longitude=").concat(long);
                    } else {
                        if (geolocation.latitude && geolocation.longitude) {
                            type = geolocation.lookupType ? geolocation.lookupType : "State Set";
                            path = path + "&latitude=".concat(geolocation.latitude, "&longitude=").concat(geolocation.longitude);
                        }
                    }
                    return [
                        4,
                        axios/* default.get */.Z.get(path, {
                            crossdomain: true
                        })
                    ];
                case 2:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getGeoLocationByLatLong(lat, long, geolocation) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
;// CONCATENATED MODULE: ./src/components/home/PlacesSearch/PlacesModal.jsx



var PlacesModal = function(props) {
    var headerName = "1-800-Battery";
    if (props.masterProvider && props.masterProvider.isActive) {
        headerName = props.masterProvider.name;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_modal_esm/* default */.Z, {
        classNames: {
            modal: "location-permission-modal",
            closeButton: "close-btn"
        },
        open: props.isOpen,
        onClose: props.onCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: "Hi, it's ".concat(headerName)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "We would love to help you, but first we need to know where you are at. Our products and service availability are dependent on where you are located."
                }),
                props.isGeolocationEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "buttons",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        disabled: props.locationPermissionApprovedLoading,
                        className: "btn btn-success ".concat(props.locationPermissionApprovedLoading ? "disabled" : ""),
                        onClick: function() {
                            return props.getCurrentLocation();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: props.locationPermissionApprovedLoading ? "fas fa-circle-notch fa-spin" : "fas fa-map-marker-alt"
                            }),
                            " Yes. Use My Location."
                        ]
                    })
                }) : "",
                props.isGeolocationEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "or-container mt-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "OR"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line"
                        })
                    ]
                }) : "",
                !props.isGeolocationEnabled && props.isGeolocationAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "or-container mt-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "My Location is:"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line"
                        })
                    ]
                }) : "",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "place-selection extended",
                    children: [
                        props.loadingCurrentGeolocation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "input-loading-status",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-circle-notch fa-spin"
                                }),
                                "Loading your location..."
                            ]
                        }),
                        props.children
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/home/PlacesSearch/index.jsx




var PlacesSearch_this = undefined;











var timeout;
var autocompletePlaces = function(getDataFromPlace, options, formattedAddress, onKeyDown) {
    var solo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_autocomplete["default"], (0,_object_spread/* default */.Z)({
        apiKey: "AIzaSyBwExoDhRsIjCbY44quSOdqDkx1QPWpD4A",
        onPlaceSelected: getDataFromPlace,
        options: options,
        defaultValue: formattedAddress,
        className: solo ? "search-location-input" : "search-location-input search-location-input--modal",
        placeholder: "Please enter City, Zip or Address"
    }, onKeyDown && {
        onKeyDown: function() {
            return onKeyDown();
        }
    }));
};
var PlacesSearch = function(props) {
    var router = (0,next_router.useRouter)();
    var isModalOpen = props.isModalOpen, _isFull = props.isFull, isFull = _isFull === void 0 ? true : _isFull;
    var options = {
        types: props.addressSearch ? [
            "address"
        ] : [
            "(regions)"
        ],
        componentRestrictions: {
            country: [
                "us",
                "ca"
            ]
        }
    };
    var ref = (0,react.useState)(false), dataSet = ref[0], setDataSet = ref[1];
    var ref1 = (0,react.useState)(undefined), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(false), isUserTyping = ref2[0], setIsUserTyping = ref2[1];
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(false), locationPermissionApprovedLoading = ref4[0], setLocationPermissionApprovedLoading = ref4[1];
    var ref5 = (0,react.useState)(false), loadingCurrentGeolocation = ref5[0], setLoadingCurrentGeolocation = ref5[1];
    var ref6 = (0,react.useState)(false), isGeolocationEnabled = ref6[0], setIsGeolocationEnabled = ref6[1];
    var ref7 = (0,react.useState)(false), isGeolocationAvailable = ref7[0], setIsGeolocationAvailable = ref7[1];
    var getGeoLocation = function() {
        var geoidx = localStorage.getItem("_mr_geoidx");
        if (geoidx && geoidx !== "undefined") {
            return JSON.parse(geoidx);
        }
        return null;
    };
    (0,react.useEffect)(function() {
        setIsOpen(isModalOpen);
    }, [
        isModalOpen
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = props.address) === null || ref === void 0 ? void 0 : ref.isLocationLoading) !== loadingCurrentGeolocation) {
            props.setLocationLoading(loadingCurrentGeolocation);
        }
    }, [
        loadingCurrentGeolocation
    ]);
    (0,react.useEffect)(function() {
        setIsGeolocationEnabled(props.isGeolocationEnabled);
        setIsGeolocationAvailable(props.isGeolocationAvailable);
    }, [
        props
    ]);
    var getData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var geolocation, dt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        geolocation = getGeoLocation();
                        if (!(geolocation && (geolocation === null || geolocation === void 0 ? void 0 : geolocation.latitude) !== null)) return [
                            3,
                            2
                        ];
                        setLoadingCurrentGeolocation(true);
                        return [
                            4,
                            getGeoLocationByLatLong(geolocation === null || geolocation === void 0 ? void 0 : geolocation.latitude, geolocation === null || geolocation === void 0 ? void 0 : geolocation.longitude, geolocation)
                        ];
                    case 1:
                        dt = _state.sent();
                        if (props.addressSearch) {
                            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dt), {
                                formattedAddress: dt.formatted_address
                            }));
                        } else {
                            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dt), {
                                formattedAddress: "".concat(dt.city, " ").concat(dt.state, ", ").concat(dt.country)
                            }));
                        }
                        setLoadingCurrentGeolocation(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setData(null);
                        setLoadingCurrentGeolocation(false);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var crit = router.query.crit;
        var getCritGeo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var payload;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,utils_geolocation/* fetchCritAndZip */.Ic)(crit, true)
                            ];
                        case 1:
                            payload = _state.sent();
                            if (payload == null) {
                                return [
                                    2
                                ];
                            }
                            setData(payload);
                            if (props.address.latitude !== payload.latitude && props.address.longitude !== payload.longitude) {
                                props.setLocation(payload);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function getCritGeo() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!data) {
            if (crit) {
                getCritGeo();
            } else {
                getData();
            }
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        if (!data && dataSet === false) {
            if (props.address.latitude && props.address.longitude) {
                props.setLocation(props.address);
                setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.address), {
                    formattedAddress: props.address.formatted_address
                }));
                setDataSet(true);
            }
        }
    }, [
        props.address,
        data
    ]);
    (0,react.useEffect)(function() {
        // Because we have input fields inside of the page content
        var modalNotRequired = window.location.href.includes("category") || window.location.href.includes("product");
        if (!modalNotRequired) {
            if (isModalOpen !== false) {
                if (data) {
                    timeout = setTimeout(function() {
                        return setIsOpen(true);
                    }, 5000);
                    if (data) {
                        clearTimeout(timeout);
                    }
                }
            }
        }
    }, [
        data,
        isModalOpen
    ]);
    (0,react.useEffect)(function() {
        if (isUserTyping) {
            clearTimeout(timeout);
        }
    }, [
        isUserTyping
    ]);
    var getDataFromPlace = function(place) {
        setLoadingCurrentGeolocation(true);
        var data = getAddressData(place);
        if (data) {
            setAddressData(data ? data : null);
        }
        setTimeout(function() {
            return setLoadingCurrentGeolocation(false);
        }, 1000);
    };
    var onCloseModal = function() {
        return setIsOpen(false);
    };
    var setAddressData = function(addressData) {
        var short = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var formattedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressData), {
            formattedAddress: short ? "".concat(addressData.city, ", ").concat(addressData.country) : (addressData === null || addressData === void 0 ? void 0 : addressData.formatted_address) || (addressData === null || addressData === void 0 ? void 0 : addressData.formattedAddress),
            formatted_address: short ? "".concat(addressData.city, ", ").concat(addressData.country) : (addressData === null || addressData === void 0 ? void 0 : addressData.formatted_address) || (addressData === null || addressData === void 0 ? void 0 : addressData.formattedAddress)
        });
        setData(formattedData);
        props.setLocation(formattedData);
        setTimeout(function() {
            return setIsOpen(false);
        }, 2000);
    };
    var onKeyDown = function() {
        setIsUserTyping(true);
    };
    var requestLocation = function() {
        setLoadingCurrentGeolocation(true);
        if (!navigator.geolocation) {
            dist/* default.error */.ZP.error("Geolocation is not supported by your browser");
            PlacesSearch_this.requestLocation();
            setLoadingCurrentGeolocation(false);
        }
        if (!navigator.geolocation || !props.isGeolocationEnabled) {
            dist/* default.error */.ZP.error("Geolocation is not supported by your browser");
            setLoadingCurrentGeolocation(false);
        } else {
            navigator.geolocation.getCurrentPosition(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(position) {
                    var latitude, longitude, location;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                latitude = position.coords.latitude;
                                longitude = position.coords.longitude;
                                return [
                                    4,
                                    getGeoLocationByLatLong(latitude, longitude, props.geolocation)
                                ];
                            case 1:
                                location = _state.sent();
                                setAddressData(location, true);
                                props.setLocation(location);
                                setLoadingCurrentGeolocation(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(position) {
                    return _ref.apply(this, arguments);
                };
            }(), function(error) {
                if (error.code == 3 && !props.geolocation.latitude) {
                    dist/* default.error */.ZP.error("We were unable to retrieve your location. Please enter it manually in the location form");
                }
                setLoadingCurrentGeolocation(false);
            }, {
                timeout: 30000,
                enableHighAccuracy: true,
                maximumAge: Infinity
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            !props.modalOnly && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "place-selection extended ".concat(props.hasMyLocationButton && "has-my-location"),
                        children: isFull ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                props.hasMyLocationButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn",
                                            onClick: function() {
                                                return requestLocation();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-map-marker-alt",
                                                    "aria-hidden": "true"
                                                }),
                                                " Use My Location"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "or-container mt-2 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "OR"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-pack",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "location-icon-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-map-marker-alt"
                                            })
                                        }),
                                        autocompletePlaces(getDataFromPlace, options, data === null || data === void 0 ? void 0 : data.formattedAddress, onKeyDown)
                                    ]
                                })
                            ]
                        }) : autocompletePlaces(getDataFromPlace, options, data === null || data === void 0 ? void 0 : data.formattedAddress, onKeyDown)
                    }),
                    props.coords && props.coords.latitude
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesModal, {
                isOpen: isOpen,
                onCloseModal: onCloseModal,
                locationPermissionApprovedLoading: locationPermissionApprovedLoading,
                isGeolocationEnabled: isGeolocationEnabled,
                isGeolocationAvailable: isGeolocationAvailable,
                loadingCurrentGeolocation: loadingCurrentGeolocation,
                getCurrentLocation: function() {
                    setLocationPermissionApprovedLoading(true);
                    requestLocation();
                },
                children: autocompletePlaces(getDataFromPlace, options, data === null || data === void 0 ? void 0 : data.formattedAddress, null, false)
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        masterProvider: state.masterProvider,
        address: state.geolocation
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        setLocation: function(payload) {
            return dispatch(geolocation/* setLocation */.l6(payload));
        },
        resetLocation: function(payload) {
            return dispatch(geolocation/* resetLocation */.Rz(payload));
        },
        setLocationLoading: function(payload) {
            return dispatch(geolocation/* setLocationLoading */.bQ(payload));
        }
    };
};
/* harmony default export */ var home_PlacesSearch = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)((0,dist_modules/* geolocated */.eI)({
    suppressLocationOnMount: true,
    positionOptions: {
        enableHighAccuracy: true
    },
    watchPosition: false,
    isOptimisticGeolocationEnabled: true,
    userDecisionTimeout: 30000,
    onSuccess: function(position) {
        PlacesSearch_this.onSuccess(position);
    },
    positionError: function(error) {
        PlacesSearch_this.positionError(error);
    }
})(PlacesSearch)));


/***/ })

}]);